//export const ApiUrl = 'http://localhost:5000/';
export const ApiUrl = 'https://tablet-api.pocketperry.com/';
